import { z } from 'zod';

export const DbClassicPinComponentTypeSchema = z.enum([
  'spinner',
  'text',
  'image',
  'hotspot',
  'timer',
  'audio',
  'symbol',
  'trafficlight',
  'dropzone',
  'video',
  'formula',
  'table',
]);

export type DbClassicPinComponent = z.infer<typeof DbClassicPinComponentTypeSchema>;
